import { createFileRoute, Outlet } from "@tanstack/react-router";

import { AppShell } from "@/components/layouts/AppShell";

import { makeProfileQuery, makeReviewQuery } from "./-queries";

export const Route = createFileRoute("/app/profile/worker/$workerId")({
  loader: ({ params, context }) => {
    // ensure profile + worker reviews are prefetched for all child routes
    context.queryClient.ensureQueryData(makeProfileQuery(params.workerId));
    context.queryClient.ensureQueryData(makeReviewQuery(params.workerId));
    return {};
  },
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <AppShell>
      <Outlet />{" "}
    </AppShell>
  );
}
